import { api } from '@/core/api/'
const URL = 'api/LoadControl'

export default {
  search(payload) {
    return api.get(`${URL}/search`, {
      params: {
        ...payload
      }
    })
  },
  update(processId) {
    return api.put(`${URL}/update/${processId}`)
  }
}
